import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    gridItem: {
        padding: theme.spacing(0),
        paddingRight: '0.6rem',
        textAlign: 'center',
        fontWeight: 400,
        color: theme.palette.text.secondary,
        userSelect: 'none',
    },
    gridItemLoading: {
        padding: theme.spacing(0),
        paddingRight: '0.6rem',
        textAlign: 'center',
        fontWeight: 400,
        opacity: '0.2',
        userSelect: 'none',
    },
    totalPriceInfo: {
        color: theme.palette.primary.dark,
        display: 'flex',
        lineHeight: '19px',
        fontSize: '1.250rem',
        fontWeight: 600,
        textAlign: 'left',
        '& > div': {
            flexGrow: 1,
        },
    },
    totalPriceMonthly: {
        color: 'black',
        lineHeight: '19px',
        fontSize: '1.875rem',
        fontWeight: 700,
        marginBottom: '0.5rem',
        textAlign: 'center',
    },
    totalPriceYearly: {
        color: theme.palette.primary.light,
        lineHeight: '19px',
        fontSize: '1rem',
    },
    discountPriceInfo: {
        color: theme.palette.primary.dark,
        fontSize: '1rem',
    },
    small: {
        color: theme.palette.primary.dark,
        lineHeight: '19px',
        fontSize: '1rem',
    },
    priceMain: {
        backgroundColor: theme.palette.background.paper,
        borderTop: '2px solid ',
        borderBottom: '2px solid ',
        borderColor: theme.palette.primary.dark,
        minWidth: 270, // discuss with michael, only affects iPhone 5/SE
        overflow: 'hidden',
        '& section': {
            position: 'relative',
        },
        padding: '2rem 0 1.8rem 0rem',
    },
}));
